
export default (state = {}, action) => { // eslint-disable-line
  switch (action.type) {
    default:
      return state;
  }
};
